import React, { useEffect } from 'react';
import FacialLiveness from '../../components/FacialLiveness'; // Import the FacialLiveness component
import { useSelector, useDispatch } from 'react-redux'; // <-- add useDispatch
import { punchIn, punchOut, clearPunchState } from '../../features/currentJobsite/currentJobsiteSlice'; // <-- import actions
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';


const Punch = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  //redux store
  const {language} = useSelector((state) => state.workerAuth.workerUser);
  const { jobsite, punchMachine, nextPunchType } = useSelector((state) => state.currentJobsite);
  const { latitude, longitude } = useSelector((state) => state.workerAuth.workerLocation);

  // Callback for liveness result
  //The isLive result and sessionId are passed from the facialLiveness component.
  const handleLivenessResult = async (isLive, sessionId) => {
  if (isLive) {
    const punchData = {
      jobsiteId: jobsite.id,
      workerLat: latitude,
      workerLong: longitude,
      sessionId
    };

    try {
      if (nextPunchType === 'clockIn') {
        await dispatch(punchIn(punchData)).unwrap();
        toast.success('Clock in successful');
      } else if (nextPunchType === 'clockOut') {
        await dispatch(punchOut(punchData)).unwrap();
        toast.success('Clock out successful');
      }
    } catch (error) {
      toast.error(error || 'Face match failed. Please try again.');
    } finally {
      dispatch(clearPunchState());
      navigate('/workerDash');
    }
  } else {
    toast.error('Liveness check failed.');
    navigate('/workerDash');
  }
};



  useEffect(() => {
    console.log('nextPunchType changed:', nextPunchType);
  }, [nextPunchType]);

  
  
  return (
    <>
      <div className="container">
        <h1 style={{ fontSize: '2rem', color: '#333' }}>
          {nextPunchType === 'clockIn' ? 'Clocking In' : nextPunchType === 'clockOut' ? 'Clocking Out' : ''}
        </h1>

        {!punchMachine && (
          <FacialLiveness
            onLivenessResult={handleLivenessResult}
            language={language}
          />
        )}

     
      </div>
    </>
  );
};

export default Punch;